import { render, staticRenderFns } from "./HeaderNavigationTablet.vue?vue&type=template&id=5ffc9f10&scoped=true&"
import script from "./HeaderNavigationTablet.vue?vue&type=script&lang=js&"
export * from "./HeaderNavigationTablet.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNavigationTablet.vue?vue&type=style&index=0&id=5ffc9f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc9f10",
  null
  
)

export default component.exports